import React, { useEffect, useState } from "react"
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Typography,
  TextField,
  IconButton,
} from "@material-ui/core"
import { Delete } from "@material-ui/icons"
import AddCircleIcon from "@material-ui/icons/AddCircle"
import Select from "react-select"
import { updateParentRole, createParentRole } from "../../actions/roles"
import { useDispatch } from "react-redux"
import { openSnackBar } from "../../actions/snack-bar"

const ParentRoleDialog = ({ currentRole, apiData, onClose, open }) => {
  const [children, setChildren] = useState([])
  const [parentName, setParentName] = useState("")

  const dispatch = useDispatch()

  useEffect(
    () => {
      if (
        currentRole &&
        currentRole.tableData &&
        currentRole.tableData.childRows
      ) {
        const newChildren = currentRole.tableData.childRows.map(x => {
          delete x.tableData
          delete x.type
          return x
        })
        setChildren(newChildren)
      } else {
        setChildren([])
      }
    },
    [currentRole]
  )

  const handleSave = () => {
    const newRole = {
      id: currentRole.id,
      name:
        document.getElementById("parent-role-name").value === ""
          ? parentName
          : document.getElementById("parent-role-name").value,
      children: children.filter(x => x.name),
    }
    if (!newRole.id) {
      dispatch(createParentRole(newRole))
        .then(onClose)
        .catch(err => {
          console.log(err)
          dispatch(openSnackBar({ message: "Error creating new parent" }))
        })
    } else {
      dispatch(updateParentRole(newRole))
        .then(onClose)
        .catch(err => {
          console.log(err)
          dispatch(openSnackBar({ message: "Error updating parent" }))
        })
    }
  }
  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogContent
        style={{
          backgroundColor: "#5241a3",
          padding: "20px",
        }}
      >
        <Typography variant="h5" style={{ color: "#ffffff" }}>
          New Parent
        </Typography>
      </DialogContent>
      <DialogContent style={{ minWidth: "400px" }}>
        <Box>
          {open && (
            <Box width="100%">
              <TextField
                label="Name"
                id="parent-role-name"
                defaultValue={currentRole && currentRole.name}
                style={{ display: "grid" }}
                onChange={e => setParentName(e.target.value)}
              />
            </Box>
          )}

          <Box width="100%" marginBottom="200px" marginTop="10px">
            <Box display="flex" alignItems="center">
              <IconButton
                onClick={() => {
                  setChildren([{}, ...children])
                }}
              >
                <AddCircleIcon style={{ color: "#5241a3" }} />
              </IconButton>
              <Typography variant="h8">New Child</Typography>
            </Box>
            {children.map((x, i) => {
              // find other ids so the same child role cannot be set multiple times
              const otherChildIds = children
                .filter((_y, ii) => i !== ii)
                .map(y => y.id)
              return (
                <Box display="flex" alignItems="center" key={i}>
                  <Box style={{ flexGrow: 1 }}>
                    <Select
                      value={x}
                      // filter out previously used roles
                      options={apiData.children.filter(
                        y => otherChildIds.indexOf(y.id) === -1
                      )}
                      getOptionLabel={option => option.name}
                      getOptionValue={option => option.name}
                      onChange={newRole => {
                        setChildren(
                          children.map((y, ii) => {
                            if (i === ii) {
                              return newRole
                            }
                            return y
                          })
                        )
                      }}
                    />
                  </Box>

                  <IconButton
                    onClick={() => {
                      setChildren(children.filter((_y, ii) => i !== ii))
                    }}
                  >
                    <Delete color="secondary" />
                  </IconButton>
                </Box>
              )
            })}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={() => onClose()} color="secondary">
          Close
        </Button>
        <Box />
        <Button variant="contained" onClick={handleSave} color="primary">
          Save Parent
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ParentRoleDialog
